import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/alert-dialog/alert-dialog'
import { buttonVariants } from '@/components/button/variant'

import { type CategoryItem } from '@/lib/queries/business/v1/case/path/types'

export interface CategoryDeleteConfirmDialogProps {
  open: boolean
  deletedCategories: CategoryItem[]
  onClose: VoidFunction
  onConfirm: VoidFunction
}

export const CategoryDeleteConfirmDialog = ({
  open,
  deletedCategories,
  onClose,
  onConfirm,
}: CategoryDeleteConfirmDialogProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {deletedCategories?.length === 1
              ? `Deleting "${deletedCategories[0].path_name}"`
              : `Deleting ${deletedCategories.length} categories`}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {deletedCategories?.length === 1
              ? `Are you sure you want to delete ${deletedCategories[0].path_name}? It will be removed
            from all applicant category lists.`
              : `Are you sure you want to delete these categories? They will be removed from all applicant's category lists.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction className={buttonVariants({ variant: 'destructive' })} onClick={onConfirm}>
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
